import pkg from "../../package.json";

export default {
  API_URL: "https://api-cms.madmax.kkv-test.com/v1",
  PLAYER_URL: "https://player.madmax.kkv-test.com",
  CHATROOM_URL: "https://chatroom.madmax.kkv-test.com",
  DEFAULT_LOCALE: "en",
  VERSION: pkg.version,
  BUILD: "3322493",
  GTM_ID: process.env.REACT_APP_GTM_ID || "GTM-N9Z6X44",
  EVENT_SITE_URL: "https://event.madmax.kkv-test.com",
};
